import type { Column } from "@tanstack/react-table";
import type { DocumentRowFragment } from "../client/generated";
import { Button } from "@acdc2/ui/components/button";
import { Input } from "@acdc2/ui/components/input";
import { Icon } from "@mdi/react";
import { mdiClose } from "@mdi/js";

type Props = {
  column: Column<DocumentRowFragment>;
  placeholder: string;
};

export function DocumentTableSearch({ column, placeholder }: Props) {
  return (
    <div className="flex relative">
      <Input
        type="search"
        placeholder={placeholder}
        value={(column.getFilterValue() as string) ?? ""}
        onChange={(event) => column.setFilterValue(event.target.value)}
      />
      {column.getIsFiltered() && (
        <Button
          variant="ghost"
          size="icon"
          className="absolute right-0 size-8 m-0.5"
          onClick={() => column.setFilterValue("")}
        >
          <Icon path={mdiClose} size="1.25rem" />
        </Button>
      )}
    </div>
  );
}
